import pick from "lodash/fp/pick";

export default function selectUserGearEquipmentOptions(state) {
  return pick(["customise-pads", "customise-glove", "customise-blocker"])(
    state?.app?.userChoiceValues
  );
}
